import { render, staticRenderFns } from "./StoresChangePassword.vue?vue&type=template&id=5a27fbcc&scoped=true&"
import script from "./StoresChangePassword.vue?vue&type=script&lang=js&"
export * from "./StoresChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27fbcc",
  null
  
)

export default component.exports